import {
  BsTelephoneFill,
  BsPuzzle,
  BsCardChecklist,
  BsFillGearFill,
  BsFillGridFill,
  BsPerson,
  BsHeart,
  BsInstagram,
  BsPlusLg,
  BsCalendarCheck,
  BsFillCalendarCheckFill,
  BsCheckCircle,
} from 'react-icons/bs';
import {
  FaUserAlt,
  FaTools,
  FaHandHoldingUsd,
  FaArrowRight,
  FaThList,
  FaRegNewspaper,
  FaBath,
  FaWalking,
  FaRegHandshake,
  FaPercent,
  FaTabletAlt,
  FaMapMarkerAlt,
  FaShare,
  FaBed,
} from 'react-icons/fa';
import {
  MdOutlineMailOutline,
  MdOutlinePanTool,
  MdOutlineVerified,
  MdOutlineTimer,
  MdEngineering,
  MdOutlineManageAccounts,
  MdHomeWork,
  MdSimCardDownload,
  MdOutlineFilterList,
  MdOutlineFilterListOff,
} from 'react-icons/md';
import {
  RiMoneyDollarCircleLine,
  RiUserHeartLine,
  RiTimerFlashLine,
  RiArrowRightSLine,
  RiArrowLeftSLine,
  RiArrowDownSLine,
  RiPencilRulerLine,
} from 'react-icons/ri';
import { TbChecklist, TbHandClick, TbTarget } from 'react-icons/tb';
import { BiTimer, BiMap, BiBuildingHouse, BiErrorCircle, BiMedal } from 'react-icons/bi';
import { CgSearchFound } from 'react-icons/cg';
import { VscPerson } from 'react-icons/vsc';
import { AiOutlineWhatsApp, AiFillYoutube } from 'react-icons/ai';
import { GrClose, GrFormPrevious, GrFormNext } from 'react-icons/gr';
import { ImArrowRight } from 'react-icons/im';
import { IoBedOutline, IoTrashOutline } from 'react-icons/io5';
import { IoMdArrowDropleft, IoMdArrowDropright } from 'react-icons/io';
import { TfiFacebook } from 'react-icons/tfi';
import { GiReceiveMoney, GiHomeGarage } from 'react-icons/gi';
import {
  HiClipboard,
  HiClipboardCheck,
  HiOutlineClipboardCheck,
} from 'react-icons/hi';
import { GoSearch } from 'react-icons/go';

export const icons = {
  FaUserAlt,
  BsTelephoneFill,
  MdOutlineMailOutline,
  TbChecklist,
  MdOutlinePanTool,
  FaTools,
  MdOutlineVerified,
  FaHandHoldingUsd,
  BsPuzzle,
  BsCardChecklist,
  RiMoneyDollarCircleLine,
  BsFillGearFill,
  BiTimer,
  FaArrowRight,
  BiMap,
  BsFillGridFill,
  FaThList,
  BsPerson,
  FaRegNewspaper,
  MdOutlineTimer,
  RiUserHeartLine,
  TbHandClick,
  CgSearchFound,
  RiTimerFlashLine,
  VscPerson,
  AiOutlineWhatsApp,
  GrClose,
  ImArrowRight,
  BsHeart,
  BiBuildingHouse,
  IoBedOutline,
  FaBath,
  FaWalking,
  FaRegHandshake,
  FaPercent,
  TbTarget,
  TfiFacebook,
  BsInstagram,
  AiFillYoutube,
  RiArrowRightSLine,
  RiArrowLeftSLine,
  MdEngineering,
  FaTabletAlt,
  MdOutlineManageAccounts,
  GiReceiveMoney,
  BsPlusLg,
  GrFormPrevious,
  GrFormNext,
  IoMdArrowDropleft,
  IoMdArrowDropright,
  HiClipboard,
  HiOutlineClipboardCheck,
  BsCalendarCheck,
  GoSearch,
  IoTrashOutline,
  MdHomeWork,
  BiErrorCircle,
  FaMapMarkerAlt,
  RiArrowDownSLine,
  FaShare,
  MdSimCardDownload,
  RiPencilRulerLine,
  FaBed,
  BsFillCalendarCheckFill,
  GiHomeGarage,
  BsCheckCircle,
  HiClipboardCheck,
  MdOutlineFilterList,
  MdOutlineFilterListOff,
  BiMedal
};
